// Unique key in fetch response JSON identifying response as 'special'
// 'special' responses are returned from API eg. when redirect is required
export const RESERVED_KEY = '__redirectType';

// types
export const URI = 'URI';
export const CUSTOMER_LOAD = 'CUSTOMER_LOAD';
export const RE_AUTHENTICATE = 'RE_AUTHENTICATE';
export const AUTHORISATION_PROBLEM = 'AUTHORISATION_PROBLEM';
export const STORE_PICK = 'STORE_PICK';

// required type fields
// URI
export const LOCATION = 'location';

// CUSTOMER_LOAD
export const REASON = 'reason';

// RE_AUTHENTICATE
export const CURRENT_AUTHENTICATION_LEVEL = 'currentAuthenticationLevel';
export const REQUIRED_AUTHENTICATION_LEVEL = 'requiredAuthenticationLevel';

// AUTHORISATION_PROBLEM
export const AUTHORISATION_VIOLATION = 'authorisationViolation';

// reasons
export const SSO_SESSION_SYNC_NEEDED = 'SSO_SESSION_SYNC_NEEDED';
export const ANOTHER_SESSION_EXISTS = 'ANOTHER_SESSION_EXISTS';
export const REDIRECTING_TO_ANOTHER_SERVER = 'REDIRECTING_TO_ANOTHER_SERVER';
export const FAILED_PAYMENTS = 'FAILED_PAYMENTS';
export const LOAD_CUSTOMER_OVERFLOW = 'LOAD_CUSTOMER_OVERFLOW';
export const UNABLE_TO_LOGIN_CUSTOMER_VIA_REMEMBER_ME = 'UNABLE_TO_LOGIN_CUSTOMER_VIA_REMEMBER_ME';

export const API_ERROR_TYPES = [
  URI,
  CUSTOMER_LOAD,
  RE_AUTHENTICATE,
  AUTHORISATION_PROBLEM,
  STORE_PICK,
];

export const REQUIRED_FIELDS = {
  [URI]: [
    LOCATION,
  ],
  [CUSTOMER_LOAD]: [
    REASON,
  ],
  [RE_AUTHENTICATE]: [
    CURRENT_AUTHENTICATION_LEVEL,
    REQUIRED_AUTHENTICATION_LEVEL,
  ],
  [AUTHORISATION_PROBLEM]: [
    AUTHORISATION_VIOLATION,
  ],
  [STORE_PICK]: [],
};
